import { TTicketDetails } from '@daymade/api-contracts';
import { GameType, PurchasingAction } from '@daymade/common-lib/dbEnums';
import { IEntryLine } from 'types/Draws';

type TicketEntry = TTicketDetails['entries'][number];

const SUBSCRIPTION_ACTIONS = new Set([
  PurchasingAction.SUBSCRIPTION,
  PurchasingAction.SUBSCRIPTION_INITIAL,
  PurchasingAction.SUBSCRIPTION_UPGRADE,
]);

export const toLotteryEntries = (
  entries: TTicketDetails['entries'] = [],
): IEntryLine[] =>
  entries
    .filter(
      (entry): entry is Extract<TicketEntry, { type: GameType.LOTTERY }> =>
        entry.type === GameType.LOTTERY,
    )
    .map((entry) => entry as unknown as IEntryLine);

export const groupEntriesByPurchasingAction = (tickets: TTicketDetails[]) => {
  const subscriptionTickets = tickets.filter((ticket) =>
    SUBSCRIPTION_ACTIONS.has(ticket.paymentRequest.purchasingAction),
  );

  const addonTickets = tickets.filter(
    (ticket) =>
      !SUBSCRIPTION_ACTIONS.has(ticket.paymentRequest.purchasingAction),
  );

  const subscriptionEntries = toLotteryEntries(subscriptionTickets[0]?.entries);
  const addonEntries = addonTickets.flatMap((ticket) =>
    toLotteryEntries(ticket.entries),
  );

  return { subscriptionEntries, addonEntries };
};
